<template>
    <div class="ut-mb-3 ut-mr-5 ut-p-4 ut-mb-3 ut-flex">
        <img src="@/assets/images/info.svg" alt="" class="ut-mx-0" />
        <div v-if="info" class="ut-text-sm ut-mx-0 ut-pl-3">{{ info }}</div>
        <div v-else-if="$slots.default" class="ut-pl-3">
          <slot></slot>
        </div>
    </div>
</template>

<script>

export default {
  name: 'InfoCard',
  props: {
    info: {
      type: String,
      required: false,
    },
  },
};

</script>

<style lang="scss" scoped>
  div {
  border-radius: 3px;
  background-color: #fef7e3;

  p {
    line-height: 1.2;
  }

  // img {
  //     @apply ut-mr-3 ut-float-left;
  //     width: 20px;
  //     vertical-align: middle;
  // }
}
</style>
